import { render } from "./AddOverride.vue?vue&type=template&id=4839486a"
import script from "./AddOverride.vue?vue&type=script&lang=js"
export * from "./AddOverride.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__